var map = {
  "./cs.json": [
    "VB",
    [
      "ro4"
    ]
  ],
  "./en.json": [
    "Sw",
    [
      "w1n"
    ]
  ],
  "./pl.json": [
    "swy",
    [
      "6hc"
    ]
  ],
  "./ru.json": [
    "FnO",
    [
      "n7"
    ]
  ],
  "./tr.json": [
    "FmR",
    [
      "fa"
    ]
  ],
  "./ja.json": [
    "MHz",
    [
      "qe"
    ]
  ],
  "./zh.json": [
    "j5v",
    [
      "da"
    ]
  ],
  "./pt-br.json": [
    "kwI",
    [
      "mn"
    ]
  ],
  "./de.json": [
    "E6",
    [
      "2v"
    ]
  ],
  "./es.json": [
    "X4",
    [
      "5xl"
    ]
  ],
  "./fr.json": [
    "UR",
    [
      "ul9"
    ]
  ],
  "./it.json": [
    "Ox",
    [
      "ky"
    ]
  ],
  "./ko.json": [
    "lAl",
    [
      "3ur"
    ]
  ],
  "./pt.json": [
    "t9u",
    [
      "nk"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "nn";
module.exports = __rspack_async_context;
